import ConfirmClearPlanModal from './ConfirmClearPlanModalWrapper'

export default ConfirmClearPlanModal
